import {
    GET_GHOST_ACCOUNT,
    CREATE_GHOST_ACCOUNT,
    UPDATE_GHOST_ACCOUNT_STATUS,
    DELETE_GHOST_ACCOUNT,
    OPEN_GHOST_ACCOUNT_DIALOG,
    CLOSE_GHOST_ACCOUNT_DIALOG,
} from "./types";

const initialState = {
    ghostAccounts: [],
    dialog: false,
    dialogData: null,
};

const ghostAccountReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_GHOST_ACCOUNT:
            return {
                ...state,
                ghostAccounts: action.payload,
            };
        case CREATE_GHOST_ACCOUNT:
            const data = [...state.ghostAccounts];
            data.unshift(action.payload);
            return {
                ...state,
                ghostAccounts: data,
            };
        case UPDATE_GHOST_ACCOUNT_STATUS:
            return {
                ...state,
                ghostAccounts: state.ghostAccounts.map((ghostAccount) => {
                    if (ghostAccount._id === action.payload.id) return action.payload.data;
                    else return ghostAccount;
                }),
            };
        case DELETE_GHOST_ACCOUNT:
            return {
                ...state,
                ghostAccounts: state.ghostAccounts.filter(
                    (ghostAccount) => ghostAccount._id !== action.payload
                ),
            };
        case OPEN_GHOST_ACCOUNT_DIALOG:
            return {
                ...state,
                dialog: true,
                dialogData: action.payload || null,
            };
        case CLOSE_GHOST_ACCOUNT_DIALOG:
            return {
                ...state,
                dialog: false,
                dialogData: null,
            };

        default:
            return state;
    }
};

export default ghostAccountReducer;
